<template>
  <div
    v-show="open"
    ref="daumMapPostcode"
    class="daum-post-code"
  >
    <img
      class="daum-post-close-btn"
      alt="접기 버튼"
      :src="closeImgUrl"
      @click="onClose"
    >
  </div>
</template>

<script>
export default {
  name: "DaumPostCode",
  mounted() {
    let script = document.createElement('script')
    script.setAttribute('src', this.srcUrl)
    document.head.appendChild(script)
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    open(value = false) {
      if (!value) {
        return
      }

      this.onOpen()
    },
  },
  data: () => ({
    srcUrl: 'https://ssl.daumcdn.net/dmaps/map_js_init/postcode.v2.js?autoload=false',
    closeImgUrl: '//t1.daumcdn.net/postcode/resource/images/close.png',

  }),
  methods: {
    onClose() {
      this.$emit('selected')
    },
    onOpen() {
      const element_wrap = this.$refs.daumMapPostcode
      // 현재 scroll 위치를 저장해놓는다.
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      new daum.Postcode({
        width: '100%',
        height: '100%',
        oncomplete: (data) => {
          // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
          // 각 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          let addr = ''; // 주소 변수
          let extraAddr = ''; // 참고항목 변수

          //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
          if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
          }

          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          if (data.userSelectedType === 'R') {
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
              extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if (data.buildingName !== '' && data.apartment === 'Y') {
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if (extraAddr !== '') {
              extraAddr = ' (' + extraAddr + ')';
            }
          }

          // iframe을 넣은 element를 안보이게 한다.
          // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
          element_wrap.style.display = 'none';

          // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
          document.body.scrollTop = currentScroll;

          this.$emit('selected', {
            zonecode: data.zonecode,
            addr,
            extraAddr,
          })
        },
        // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
        onresize: (size) => {
          element_wrap.style.height = size.height + 'px';
        },
      }).embed(element_wrap);
    },
  }
}
</script>

<style scoped>
.daum-post-code {
  border: 1px solid;
  width: 100%;
  height: 300px;
  margin: 5px 0;
  position: relative;
}

.daum-post-close-btn {
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: -1px;
  z-index: 1;
}
</style>